"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromoTypePropertyOption = exports.isPromoTypeProperty = exports.promoTypePropertyDefinition = void 0;
const promoTypePropertyOptions = [
    'consumeractivation',
    'energydrink',
    'event',
    'occasioncampaign',
    'organics',
];
exports.promoTypePropertyDefinition = {
    name: 'promo-type',
    type: 'select',
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'options',
            argument: promoTypePropertyOptions,
        },
    ],
    multiple: false,
    default: 'energydrink',
    view: {
        label: 'Promotion type',
        readonly: true,
    },
};
const isPromoTypeProperty = (prop) => {
    return prop.name === exports.promoTypePropertyDefinition.name;
};
exports.isPromoTypeProperty = isPromoTypeProperty;
const isPromoTypePropertyOption = (option) => {
    return promoTypePropertyOptions.includes(option);
};
exports.isPromoTypePropertyOption = isPromoTypePropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvbW8tdHlwZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3Byb21vLXR5cGUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsTUFBTSx3QkFBd0IsR0FBRztJQUMvQixvQkFBb0I7SUFDcEIsYUFBYTtJQUNiLE9BQU87SUFDUCxrQkFBa0I7SUFDbEIsVUFBVTtDQUNGLENBQUE7QUFFRyxRQUFBLDJCQUEyQixHQUFHO0lBQ3pDLElBQUksRUFBRSxZQUFZO0lBQ2xCLElBQUksRUFBRSxRQUFRO0lBQ2QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsU0FBUztZQUNmLFFBQVEsRUFBRSx3QkFBd0I7U0FDbkM7S0FDRjtJQUNELFFBQVEsRUFBRSxLQUFLO0lBQ2YsT0FBTyxFQUFFLGFBQWE7SUFDdEIsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGdCQUFnQjtRQUN2QixRQUFRLEVBQUUsSUFBSTtLQUNmO0NBQzhCLENBQUE7QUFJMUIsTUFBTSxtQkFBbUIsR0FBRyxDQUFDLElBQWtCLEVBQTZCLEVBQUU7SUFDbkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLG1DQUEyQixDQUFDLElBQUksQ0FBQTtBQUN2RCxDQUFDLENBQUE7QUFGWSxRQUFBLG1CQUFtQix1QkFFL0I7QUFJTSxNQUFNLHlCQUF5QixHQUFHLENBQUMsTUFBYyxFQUFxQyxFQUFFO0lBQzdGLE9BQVEsd0JBQThDLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxDQUFBO0FBQ3pFLENBQUMsQ0FBQTtBQUZZLFFBQUEseUJBQXlCLDZCQUVyQyJ9